import { trpc } from '@tencent/tpro_rmonitor_web_server_traffic';
import React, { FC } from 'react';
import { formatByte2Mb } from '@/infrastructure/utils/digit';
import { ErrorInfo, getDefaultErrorInfo, ProblemDetailInfo } from '@/presentation/components/problem-detail-info';
import { EXCEPTION_TYPE_SORT, ExceptionTypeEnum } from '@/presentation/pages/traffic/config';
import { WithTypeCast } from '@raft/utils';

type IDetailInfo = WithTypeCast<trpc.rmonitor.web_server.IDetailInfo>;

const getExceptionText = (exceptionType: ExceptionTypeEnum) => {
  if (exceptionType === ExceptionTypeEnum.None) return [];

  // 转二进制
  const radixStr = Number(exceptionType).toString(2);
  // 补位到6位
  const radixPad = radixStr.padStart(5, '0');
  const texts: string[] = [];
  let k = 0;
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = radixPad.length - 1; i >= 0; i--) {
    const exceptionValue = Number(radixPad[i]);
    if (exceptionValue === 1) {
      const exceptionText = EXCEPTION_TYPE_SORT[k];
      texts.push(exceptionText);
    }

    k += 1;
  }

  return texts;
};

/**
 *
 * @param exceptionType
 */
export const renderTrafficExceptionType = (exceptionType: ExceptionTypeEnum) => {
  if (exceptionType === ExceptionTypeEnum.None) {
    return '无异常';
  }

  const exceptions = getExceptionText(exceptionType);

  return exceptions.join('、');
};

export const ErrorDetail: FC<{ info: IDetailInfo }> = (props) => {
  const { info } = props;
  const data = [
    ...getDefaultErrorInfo(info as ErrorInfo, true),
    { label: '异常流量', info: formatByte2Mb(info.abnormalTraffic ?? 0) },
    { label: '异常类型', info: renderTrafficExceptionType(info.exceptionType ?? 0) },
    { label: '运营商', info: info?.operator ?? '' },
    { label: '进程名', info: info?.processName ?? '' },
  ];

  return <ProblemDetailInfo
    cardProps={{ bodyStyle: { paddingTop: 12 } }}
    title={'错误详情'}
    data={data}
  />;
};
